import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';
import Moment from '../../../components/utils/Moment';
import OutreachForm from '../../administration/components/OutreachForm';
import OutreachEditForm from '../../administration/components/OutreachEditForm';
import { requestOutreachTypes, requestOutreaches, requestOutreachDetails, deleteOutreach, updatePatientMakoRx, requestMakoRxPartners } from '../../../store/outreach/OutreachActions';
import MakoRxForm from './MakoRxForm';
import { toast } from 'react-toastify';
import { isSuperAdmin, isMakoAdmin, isMakoUser } from '../../../store/current-user/CurrentUserSelectors';
import { requestAllSpecialPrograms } from '../../../store/patients/PatientsActions';

class AdvocateView extends React.Component {
  static propTypes = {
    data: PropTypes.object,
    showNotes: PropTypes.bool,
    toggleNotes: PropTypes.func,
    addAction: PropTypes.func,
  };

  constructor() {
    super();
    this.state = {
      showModal: false,
    };
  }

  searchOutreachTypes = () => {
    return this.props
      .getOutreachTypes({
        tenantId: this.props.tenantId
      })
      .then((result) => {
        const options = [];
        if (result.payload.data) {
          result.payload.data.forEach((item) =>
            options.push({ id: item.id, name: item.name }),
          );
        }
        return options;
      });
  };
  
  deleteOutreach = (id) => {
    this.props
      .deleteOutreach(id, {
        tenantId: this.props.tenantId,
      })
      .then((result) => {
        if (result.error) {
          toast.error('Something went wrong. Try again later.');
        }
        else {
          toast.success('Outreach Deleted.');
          this.props.getOutreaches({
            masterId: this.props.data.patientId,
            tenantId: this.props.tenantId,
            order: 'desc date'
          });
        }
      });
  };

  editOutreach = (id) => {
    this.props.getOutreach(id, {
      tenantId: this.props.tenantId,
    });
    this.setState({ showModal: true });
  };

  closeModal() {
    this.setState({ showModal: false });
  }

  searchMakoRxPartners = () => {
    return this.props
      .getMakoRxPartners({
        tenantId: this.props.tenantId
      })
      .then((result) => {
        const options = [];
        if (result.payload.data) {
          result.payload.data.forEach((item) =>
            options.push({ id: item.id, name: item.name }),
          );
        }
        return options;
      });
  };

  searchSpecialPrograms = () => {
    return this.props
      .getAllSpecialPrograms({
        tenantId: this.props.tenantId
      })
      .then((result) => {
        const options = [];
        if (result.payload.data) {
          result.payload.data.forEach((item) =>
            options.push({ id: item.id, name: item.name }),
          );
        }
        return options;
      });
  };

  updatePatientMakoRx = (values) => {
    return this.props
      .updatePatientMakoRx(values, {
        tenantId: this.props.tenantId
      })
      .then((result) => {
        if (result.error) {
          toast.error('Something went wrong. Try again later.');
        } else {
          toast.success('MakoRx Data Updated.');
        }
      });
  };

  formatPhoneNumber(phoneNumberString) {
    var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return '(' + match[1] + ') ' + match[2] + '-' + match[3];
    }
    return null;
  }

  render() {
    const showNotes = this.props.showNotes;
    const {
      data: info,
      toggleNotes,
      addAction,
      outreaches,
      view,
    } = this.props;
    
    const {
      isMakoAdmin,
      isMakoUser
    } = this.props;

    const makoRxMode = isMakoAdmin || isMakoUser;

    //var phoneNumber = info && info.phoneNumber && info.phoneNumber.toString();
    //const phone = (phoneNumber === undefined || phoneNumber === null || phoneNumber === 0) ? ''
    //  : '(' + phoneNumber.substring(0, 3) + ') ' + phoneNumber.substring(3, 6) + '-' + phoneNumber.substring(6, 10);
    
    return (
      <div>
        {info && (
          <div>
            <div className="widget-body clinic-activity-widget-body">
              <div className="chart-review-body" ref="VisitView">
                <div className="row">
                  <div className="col-xs-3">
                    <span className="review-label">Name</span>
                    <br />
                    <strong>{info.firstName} {info.lastName}</strong>{' '}
                  </div>
                  <div className="col-xs-3">
                    <span className="review-label">DOB</span>
                    <br />
                    <Moment date={info.DOB} format="MM/DD/YYYY" />
                  </div>
                  <div className="col-xs-3">
                    <span className="review-label">Age</span>
                    <br />
                    {info.age}
                  </div>
                  <div className="col-xs-3">
                    <span className="review-label">Gender</span>
                    <br />
                    {info.gender}
                    &nbsp;
                  </div>
                  <div className="col-sm-3 col-xs-3">
                    <span className="review-label">Athena ID</span>
                    <br />
                    {/*<a href={`https://www.app.elationemr.com/patient/${info.athenaID}/`} target="_blank">{info.athenaID}</a>*/}
                    <a href={`https://athenanet.athenahealth.com/23284/1/globalframeset.esp?&MAIN=clinicals%2Fcharttabs.esp%3FPATIENTID%3D${info.athenaID}`} target="_blank">{info.athenaID}</a>
                  </div>
                  <div className="col-sm-3 col-xs-3">
                    <span className="review-label">Home Phone</span>
                    <br />
                    {(info.homePhone !== null) && this.formatPhoneNumber(info.homePhone)}
                    &nbsp;
                  </div>
                  <div className="col-sm-3 col-xs-3">
                    <span className="review-label">Mobile Phone</span>
                    <br />
                    {(info.mobilePhone !== null) && this.formatPhoneNumber(info.mobilePhone)}
                    &nbsp;
                  </div>
                  <div className="col-sm-3 col-xs-3">
                    <span className="review-label">Email</span>
                    <br />
                    {info.email}
                    &nbsp;
                  </div>
                  <div className="col-sm-4 col-xs-4">
                    <span className="review-label">Last Outreach</span>
                    <br />
                    {(info.lastOutreachDate !== null) &&
                      <Moment date={info.lastOutreachDate} format="MM/DD/YYYY" />
                    }
                    &nbsp;
                  </div>
                  <div className="col-sm-4 col-xs-4">
                    <span className="review-label">Risk Category</span>
                    <br />
                    {info.riskCategory}
                    &nbsp;
                  </div>
                  <div className="col-sm-4 col-xs-4">
                    <span className="review-label">Risk Engaged</span>
                    <br />
                    {info.riskEngaged}
                    &nbsp;
                  </div>
                  <div className="col-sm-4 col-xs-4">
                    <span className="review-label">Visits (12 mos.)</span>
                    <br />
                    {info.visitsLast12}
                    &nbsp;
                  </div>
                  <div className="col-sm-4 col-xs-4">
                    <span className="review-label">Last Visit</span>
                    <br />
                    {(info.lastVisit !== null) ? (info.lastVisit === "") ? '' : <Moment date={info.lastVisit} format="MM/DD/YYYY" /> : ''}
                    &nbsp;
                  </div>
                  <div className="col-sm-4 col-xs-4">
                    <span className="review-label">Next Scheduled Visit</span>
                    <br />
                    {(info.nextVisitDate !== null) ? (info.nextVisitDate === "") ? '' : <Moment date={info.nextVisitDate} format="MM/DD/YYYY" /> : ''}
                    &nbsp;
                  </div>
                  <div className="col-sm-12 col-xs-12 flags">
                    <span className="review-label">Flags</span>
                    <br />
                    {info.PreDFlag === 1 && (
                      <span title="PreDiabetes" className="label label-danger">PRED</span>
                    )}
                    {info.DIAFlag === 1 && (
                      <span title="Diabetes" className="label label-warning">DIAB</span>
                    )}
                    {info.HTNFlag === 1 && (
                      <span title="Hypertension" className="label" style={{ backgroundColor: 'blue' }}>HYPT</span>
                    )}
                    {info.HLDFlag === 1 && (
                      <span title="Hyperlipidemia" className="label" style={{ backgroundColor: 'green' }}>HYPL</span>
                    )}
                    {info.AsthmaFlag === 1 && (
                      <span title="Asthma" className="label" style={{ backgroundColor: 'pink' }}>ASTH</span>
                    )}
                    {info.ObesityFlag === 1 && (
                      <span title="Obesity" className="label" style={{ backgroundColor: '#8f6900' }}>OBES</span>
                    )}
                    &nbsp;
                  </div>
                </div>
                <hr className="simple" />
                <div className="row">
                  <div className="col-xs-3">
                    <span className="review-label">Address1</span>
                    <br />
                    {info.addressLine1}
                  </div>
                  <div className="col-xs-3">
                    <span className="review-label">Address2</span>
                    <br />
                    {info.addressLine2}
                  </div>
                  <div className="col-xs-2">
                    <span className="review-label">Employer</span>
                    <br />
                    {info.employer}
                  </div>
                  <div className="col-xs-2">
                    <span className="review-label">PG</span>
                    <br />
                    {(info.PGFlag === "Yes") ? "Y" : "N"}
                  </div>
                  <div className="col-xs-2">
                    <span className="review-label">Location</span>
                    <br />
                    {info.clinicLocation}
                  </div>
                </div>
                <div className="row">
                  <div className="col-xs-3">
                    <span className="review-label">City</span>
                    <br />
                    {info.addressCity}
                  </div>
                  <div className="col-xs-3">
                    <span className="review-label">State</span>
                    <br />
                    {info.addressState}
                  </div>
                  <div className="col-xs-3">
                    <span className="review-label">Zip</span>
                    <br />
                    {info.addressZip}
                  </div>
                  <div className="col-xs-3">
                    <span className="review-label">Member Type</span>
                    <br />
                    {info.memberType}
                  </div>
                </div>
                <hr className="simple" />
                <ul id="myTab1" className="nav nav-tabs">
                  {(!makoRxMode &&
                    <li className="active">
                      <a href="#s1" data-toggle="tab" aria-expanded="true">
                        <i className="fa fa-fw fa-lg fa-user-md hidden-xs" />
                        Medical{' '}
                      </a>
                    </li>
                  )}
                  <li>
                    <a href="#s2" data-toggle="tab" aria-expanded="false">
                      <i className="fa fa-fw fa-lg fa-hospital-o hidden-xs" />{' '}
                      Claims{' '}
                    </a>
                  </li>
                  {(!makoRxMode &&
                    <li>
                      <a href="#s3" data-toggle="tab" aria-expanded="false">
                        <i className="fa fa-fw fa-lg fa-history hidden-xs" />{' '}
                        Visit History{' '}
                      </a>
                    </li>
                  )}
                  <li>
                    <a href="#s4" data-toggle="tab" aria-expanded="false">
                      <i className="fa fa-fw fa-lg fa-comments hidden-xs" />{' '}
                      Outreach History{' '}
                    </a>
                  </li>
                  {/*{(((isSuperAdmin && info.makoRx) || makoRxMode) &&*/}
                    <li>
                      <a href="#s5" data-toggle="tab" aria-expanded="false">
                        <i className="fa fa-fw fa-lg fa-list hidden-xs" />{' '}
                        ProactiveRx{' '}
                      </a>
                    </li>
                  {/*)}*/}
                </ul>
                <div id="myTabContent1" className="tab-content padding-10">
                  <div className="tab-pane fade active in" id="s1">
                    <div className="row">
                      <div className="col-xs-3">
                        <span className="review-label">ASCVD RISK</span>
                        <br />
                        {Number(info.ascvd_risk).toFixed(2)}
                      </div>
                      <div className="col-xs-3">
                        <span className="review-label">HCC SCORE</span>
                        <br />
                        {Number(info.hhs_hcc_score).toFixed(2)}
                      </div>
                      <div className="col-xs-3">
                        <span className="review-label">HCC CATEGORY</span>
                        <br />
                        {info.hhs_hcc_category}
                      </div>
                      <div className="col-xs-3">
                        <span className="review-label">CHRONIC CONDITIONS</span>
                        <br />
                        {info.chronicConditionCount}
                      </div>
                      <div className="col-xs-4">
                        <span className="review-label">TOTAL CHOLESTEROL</span>
                        <br />
                        {info.totalCholesterol}
                      </div>
                      <div className="col-xs-4">
                        <span className="review-label">HDL CHOLESTEROL</span>
                        <br />
                        {info.hdl_cholesterol}
                      </div>
                      <div className="col-xs-4">
                        <span className="review-label">LDL CHOLESTEROL</span>
                        <br />
                        {info.ldl_cholesterol}
                      </div>
                      <div className="col-xs-3">
                        <span className="review-label">SYSTOLIC BP</span>
                        <br />
                        {info.systolic_bp}
                      </div>
                      <div className="col-xs-3">
                        <span className="review-label">A1C</span>
                        <br />
                        {info.a1c}
                      </div>
                      <div className="col-xs-3">
                        <span className="review-label">SMOKING STATUS</span>
                        <br />
                        {info.smokingStatus}
                      </div>
                      <div className="col-xs-3">
                        <span className="review-label">BMI</span>
                        <br />
                        {info.bmi}
                      </div>
                    </div>
                  </div>
                  <div className="tab-pane fade" id="s2">
                    <div className="row">
                      <div className="col-xs-3">
                        <span className="review-label">HIGH COST CLAIMANT</span>
                        <br />
                        {(info.HCCFlag === 1) ? <span>YES</span> : <span>NO</span>}
                      </div>
                      <div className="col-xs-3">
                        <span className="review-label">TOTAL 12 MONTH SPEND</span>
                        <br />
                        ${Number(info.totalPaid).toFixed(2)}
                      </div>
                      <div className="col-xs-3">
                        <span className="review-label">12 MONTH MEDICAL SPEND</span>
                        <br />
                        ${Number(info.medicalPaid).toFixed(2)}
                      </div>
                      <div className="col-xs-3">
                        <span className="review-label">12 MONTH RX SPEND</span>
                        <br />
                        ${Number(info.RxPaid).toFixed(2)}
                      </div>
                    </div>
                  </div>
                  <div className="tab-pane fade" id="s3">
                    <div className="row">
                      <div className="col-xs-3">
                        <span className="review-label">VISITS (12 mos.)</span>
                        <br />
                        {info.visitsLast12}
                      </div>
                      <div className="col-xs-3">
                        <span className="review-label">VISIT GAP</span>
                        <br />
                        {info.visitGap}
                      </div>
                      <div className="col-xs-3">
                        <span className="review-label">LAST VISIT</span>
                        <br />
                        {(info.lastVisit !== null) ? (info.lastVisit === "") ? '' : <Moment date={info.lastVisit} format="MM/DD/YYYY" /> : ''}
                      </div>
                      <div className="col-xs-3">
                        <span className="review-label">NEXT VISIT</span>
                        <br />
                        {(info.nextVisitDate !== null) ? (info.nextVisitDate === "") ? '' : <Moment date={info.nextVisitDate} format="MM/DD/YYYY" /> : ''}
                      </div>
                      <div className="col-xs-4">
                        <span className="review-label">PREVENTIVE VISITS</span>
                        <br />
                        {info.preventiveVisits}
                      </div>
                      <div className="col-xs-4">
                        <span className="review-label">Last HRA/PHR Visit</span>
                        <br />
                        {info.hra_visitsDate}
                      </div>
                      <div className="col-xs-4">
                        <span className="review-label">HEALTH COACH VISITS</span>
                        <br />
                        {info.healthCoachVisits}
                      </div>
                    </div>
                  </div>
                  <div className="tab-pane fade" id="s4">
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="table-responsive">
                          <table className="table table-bordered table-condensed">
                            <thead>
                              <tr>
                                <th>Date</th>
                                <th>Advocate Name</th>
                                <th>Outreach Type</th>
                                <th>Notes</th>
                                <th>Next Follow-up</th>
                                <th>Edit</th>
                                <th>Delete</th>
                                {/*<th>Athena Case</th>*/}
                              </tr>
                            </thead>
                            <tbody>
                              {outreaches && outreaches.list && outreaches.list.map(outreach => (
                                <tr key={outreach.id}>
                                  <td>
                                    <Moment
                                      date={outreach.date}
                                      format="MM/DD/YYYY"
                                    />
                                  </td>
                                  <td>{outreach.createdByName}</td>
                                  <td>{outreach.typeName}</td>
                                  <td>{outreach.note}</td>
                                  <td>
                                    {outreach.nextFlowUpAt !== null && (
                                      <Moment
                                        date={outreach.nextFlowUpAt}
                                        format="MM/DD/YYYY"
                                      />
                                      )}
                                  </td>
                                  <td>
                                    <button className="btn btn-default btn-xs"
                                      onClick={() => this.editOutreach(outreach.id)}>
                                      <i className="fa fa-pencil" />
                                    </button>
                                  </td>
                                  <td>
                                    <button className="btn btn-default btn-xs"
                                      onClick={() => this.deleteOutreach(outreach.id)}>
                                      <i className="fa fa-trash" />
                                    </button>
                                  </td>
                                  {/*<td>{outreach.copyToAthena}</td>*/}
                                </tr>
                                ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="tab-pane fade" id="s5">
                    <div className="row">
                      {info.makoRx && (
                        <div className="col-sm-12">
                          <MakoRxForm key={info.makoRx.id} makoRx={info.makoRx} searchMakoRxPartners={this.searchMakoRxPartners} onSubmit={this.updatePatientMakoRx} searchSpecialPrograms={this.searchSpecialPrograms} />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div ref="form" className="review-notes">
                {showNotes && (
                  <OutreachForm
                    masterPatientId={info.patientId}
                    view={view}
                    toggleNotes={toggleNotes}
                    onSubmit={addAction}
                    searchOutreachTypes={this.searchOutreachTypes}
                  />
                )}
                <Modal show={this.state.showModal}>
                  <Modal.Header>
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-hidden="true"
                      onClick={this.closeModal.bind(this)}
                    >
                      &times;
                    </button>
                    <h4 className="modal-title">Edit Outreach</h4>
                  </Modal.Header>
                  <Modal.Body>
                    <OutreachEditForm
                      masterPatientId={info.patientId}
                      onCancel={this.closeModal.bind(this)}
                      onSave={this.closeModal.bind(this)}
                      onSubmit={addAction}
                      searchOutreachTypes={this.searchOutreachTypes}
                    />
                  </Modal.Body>
                </Modal>

              </div>
            </div>
          </div>
        )}
        {!info && (
          <div className="widget-body clinic-activity-widget-body empty-chart-review">
            <div>
              <i className="fa fa-lock fa-4x" />
              <h4>Select a patient to show content here</h4>
              <p>This blank page message helps protect your privacy.</p>
            </div>
          </div>
        )}
      </div>
    );
  }
}
export default connect(
  (state) => ({
    outreach: state.outreach.outreach,
    tenantId: state.currentUser.queryParams.tenantId,
    isSuperAdmin: isSuperAdmin(state),
    isMakoAdmin: isMakoAdmin(state),
    isMakoUser: isMakoUser(state),
  }),
  (dispatch) => ({
    getOutreachTypes: (params) => dispatch(requestOutreachTypes(params)),
    deleteOutreach: (id, params) => dispatch(deleteOutreach(id, params)),
    getOutreaches: (params) => dispatch(requestOutreaches(params)),
    getMakoRxPartners: (params) => dispatch(requestMakoRxPartners(params)),
    updatePatientMakoRx: (patientMakoRx, params) => dispatch(updatePatientMakoRx(patientMakoRx, params)),
    getOutreach: (id, params) => dispatch(requestOutreachDetails(id, params)),
    getAllSpecialPrograms: (params) => dispatch(requestAllSpecialPrograms(params)),
  }),
)(AdvocateView);



// WEBPACK FOOTER //
// ./src/routes/management/components/AdvocateView.js